/* Mon Livre de Vie V50 — onglets, carrousel sans scroll vertical induit */
(function(){
  function setupHow(section){
    if(!section || section.dataset.swReady==='true') return;
    section.dataset.swReady='true';
    var tabs=Array.from(section.querySelectorAll('[data-sw-tab]'));
    var panels=Array.from(section.querySelectorAll('[data-sw-panel]'));
    var prev=section.querySelector('[data-sw-previous]');
    var next=section.querySelector('[data-sw-next]');
    var counter=section.querySelector('[data-sw-count]');
    function activePanel(){return section.querySelector('[data-sw-panel]:not([hidden])');}
    function activeTrack(){var p=activePanel();return p&&p.querySelector('.mlv-sw-how__track');}
    function currentIndex(){
      var t=activeTrack();if(!t)return 0;
      var slides=Array.from(t.querySelectorAll('.mlv-sw-how__card'));
      var origin=t.getBoundingClientRect().left;
      var min=Infinity,idx=0;
      slides.forEach(function(el,i){var d=Math.abs(el.getBoundingClientRect().left-origin);if(d<min){min=d;idx=i;}});
      return idx;
    }
    function sync(){
      var t=activeTrack();if(!t)return;
      var slides=t.querySelectorAll('.mlv-sw-how__card');
      var idx=currentIndex();
      if(counter)counter.textContent=String(idx+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
      if(prev)prev.disabled=idx===0;
      if(next)next.disabled=idx>=slides.length-1;
    }
    function to(idx){
      var t=activeTrack();if(!t)return;
      var slides=t.querySelectorAll('.mlv-sw-how__card');
      if(idx<0||idx>=slides.length)return;
      t.scrollTo({left:slides[idx].offsetLeft-slides[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      window.setTimeout(sync,350);
    }
    tabs.forEach(function(tab){
      tab.addEventListener('click',function(){
        var target=tab.getAttribute('data-sw-tab');
        tabs.forEach(function(b){var selected=b===tab;b.classList.toggle('is-active',selected);b.setAttribute('aria-selected',selected?'true':'false');b.tabIndex=selected?0:-1;});
        panels.forEach(function(p){var selected=p.dataset.swPanel===target;p.hidden=!selected;p.classList.toggle('is-active',selected);if(selected){var t=p.querySelector('.mlv-sw-how__track');if(t)t.scrollLeft=0;}});
        sync();
      });
      tab.addEventListener('keydown',function(e){
        if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
        e.preventDefault();var idx=tabs.indexOf(tab)+(e.key==='ArrowRight'?1:-1);
        var dest=tabs[(idx+tabs.length)%tabs.length];dest.focus({preventScroll:true});dest.click();
      });
    });
    if(prev)prev.addEventListener('click',function(){to(currentIndex()-1);});
    if(next)next.addEventListener('click',function(){to(currentIndex()+1);});
    panels.forEach(function(p){
      var t=p.querySelector('.mlv-sw-how__track');
      if(!t)return;
      var raf=false;
      t.addEventListener('scroll',function(){if(raf)return;raf=true;requestAnimationFrame(function(){sync();raf=false;});},{passive:true});
    });
    sync();
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(e){
        section.classList.toggle('mlv-sw-how--in-view',e.isIntersecting&&e.intersectionRatio>.28);
      });},{threshold:[0,.28,.6]});io.observe(section);
    }
  }
  function setup(){
    document.querySelectorAll('.mlv-sw-how').forEach(setupHow);
    if(window.__mlvSwObserver || !('IntersectionObserver' in window))return;
    var targets=Array.from(document.querySelectorAll('#etapes, #prix .sp-gallery'));
    if(!targets.length)return;
    var present=new Set();
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting && e.intersectionRatio>.24)present.add(e.target);else present.delete(e.target);});
      document.body.classList.toggle('mlv-sw-immersive',present.size>0);
    },{threshold:[0,.25,.6]});
    targets.forEach(function(target){io.observe(target);});
    window.__mlvSwObserver=io;
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  document.addEventListener('shopify:section:load',setup);
})();
